import React from "react";
const Button = ({type, style, title, onClick ,inlineStyle,btnId, disabled, ...props}) => {
    return (
        <button type={type} onClick={onClick} id={btnId} disabled={disabled} className={`${style || ""} ${disabled ? 'disabledButton' : ''}`} style={inlineStyle} {...props}>{title}</button>
    )
}
export default Button;

